import React from "react";
import { 
    ResponsiveContainer, 
    LineChart, 
    Line, 
    XAxis, 
    YAxis, 
    CartesianGrid, 
    Tooltip 
} from "recharts";

const LineChartBase = ({ 
    data, 
    xKey, 
    yKey, 
    height = 220, 
    stroke = "#8b5cf6",
    yFormatter,         
    tooltipFormatter, 
    domain,
    padding,
    textSize=12,
}) => {

  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart 
            data={data} 
            margin={{ top: 5, right: 12, left: 12, bottom: 5 }}
        >
          <CartesianGrid 
            strokeDasharray="3 3" 
            stroke="#e2e8f0" 
          />
          <XAxis 
            dataKey={xKey} 
            tick={{ fill: "#64748b", fontSize: textSize }} 
            axisLine={{ stroke: "#64748b" }} 
            tickLine={{ stroke: "#64748b" }} 
          />
          <YAxis 
            tick={{ fill: "#64748b", fontSize: textSize }} 
            axisLine={{ stroke: "#64748b" }} 
            tickLine={{ stroke: "#64748b" }} 
            {...(domain ? { domain } : {})}
            tickFormatter={yFormatter}
            padding={padding}  
          />
          <Tooltip 
            cursor={{ stroke: "#f1f5f9" }} 
            contentStyle={{ 
                borderRadius: 8, 
                border: "1px solid #e2e8f0", 
                fontSize: textSize 
            }} 
            formatter={tooltipFormatter}  
          />
          <Line 
            type="monotone" 
            dataKey={yKey} 
            stroke={stroke} 
            strokeWidth={3} 
            dot={{ r: 5, fill: "#8b5cf6" }} 
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartBase;
